

export interface PaginationData {
  startRow: number;
  endRow: number;
  totalItems: number;
  totalPages: number;
  currentPage: number;
  pageSize: number;
}
